import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { BankAccountTransactionMatchDefinitionService } from '../../../services/BankAccountTransactionMatchDefinitionService';
import { GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest, initialGetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest } from '../../../models/request/bankAccountTransactionMatchDefinition/GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponse, GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseData, GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseItem, initialGetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseData } from '../../../models/response/bankAccountTransactionMatchDefinition/GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import BankAccountTransactionMatchDefinitionListFilters from './Components/BankAccountTransactionMatchDefinitionListFilters';
import { ExportBankAccountTransactionMatchDefinitionListResponse } from '../../../models/response/bankAccountTransactionMatchDefinition/ExportBankAccountTransactionMatchDefinitionListResponse';
import { DeleteBankAccountTransactionMatchDefinitionResponse } from '../../../models/response/bankAccountTransactionMatchDefinition/DeleteBankAccountTransactionMatchDefinitionResponse';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadConstantsByCode, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { ColumnFilterOption } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ConstantService } from '../../../services/ConstantService';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

// Eşleşme Tipi seçenekleri: filtre panelindeki gibi yalnız en alt seviyedeki formlar,
// üst başlıklarıyla birlikte ("Üst > Alt") ve alfabetik.
const loadCustomForms = async (): Promise<ColumnFilterOption[]> => {
    const response = await ConstantService.getConstantList('CUSTOM_FORM')

    if (!response.isSuccess)
        throw response.message

    const all: any[] = response.data ?? []

    return all
        .filter(item => !all.some(x => x.parentConstantId == item.constantId))
        .map(item => {
            const path: string[] = [item.value]
            var parent = all.find(x => x.constantId == item.parentConstantId)

            while (parent) {
                path.unshift(parent.value)
                const parentId = parent.parentConstantId
                parent = all.find(x => x.constantId == parentId)
            }

            return { value: String(item.constantId), label: path.join(' > ') }
        })
        .sort((x, y) => x.label.localeCompare(y.label))
}

// Hareket Tipi: veritabanında "A" Tahsilat, "B" Ödeme.
const debtOrReceivableOptions = (): Promise<ColumnFilterOption[]> => Promise.resolve([
    { value: 'A', label: 'Tahsilat' },
    { value: 'B', label: 'Ödeme' },
])

const BankAccountTransactionMatchDefinitionList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Ayarlar > Banka H. Eşleşme"
    const pageVersion = "1";
    const [data, setData] = useState<GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseData>(initialGetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest>(initialGetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Banka', name: 'bankName', order: 0, isVisible: true },
            { title: 'Transaction Id', name: 'transactionId', order: 0, isVisible: true },
            { title: 'Hareket Tipi', name: 'debtOrReceivableStr', order: 0, isVisible: true },
            { title: 'Eşleşme Tipi', name: 'customFormNameStr', order: 0, isVisible: true },
            { title: 'Banka H. Döviz Cinsi', name: 'currencyTypeName', order: 0, isVisible: true },
            { title: 'Hesap', name: 'defaultAccount', order: 0, isVisible: true },
            { title: 'Açıklama', name: 'description', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'isCustomer', order: 0, isVisible: true },
            { title: 'Tedarikçi', name: 'isSupplier', order: 0, isVisible: true },
            { title: 'Acente', name: 'isAgency', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteBankAccountTransactionMatchDefinition = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.bankAccountTransactionMatchDefinitionId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteBankAccountTransactionMatchDefinitionResponse = await BankAccountTransactionMatchDefinitionService.deleteBankAccountTransactionMatchDefinition(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateBankAccountTransactionMatchDefinition = async (_id: string | undefined = undefined) => {
        navigate('/bankaccounttransactionmatchdefinition/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].bankAccountTransactionMatchDefinitionId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponse = await BankAccountTransactionMatchDefinitionService.getBankAccountTransactionMatchDefinitionListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.bankAccountTransactionMatchDefinitionId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportBankAccountTransactionMatchDefinitionListResponse = await BankAccountTransactionMatchDefinitionService.exportBankAccountTransactionMatchDefinitionList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.bankAccountTransactionMatchDefinitionId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Bellekte üretilen metinler (hareket tipi,
    // eşleşme tipi, hesap) ve oluşturan/güncelleyen bilgisi listede yok.
    const sortableColumns = [
        'bankName', 'transactionId', 'currencyTypeName', 'description',
        'isCustomer', 'isSupplier', 'isAgency', 'isCustomActive'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (BankAccountTransactionMatchDefinitionManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        bankName: { type: 'select', loadOptions: () => loadConstants('BANK') },
        transactionId: { type: 'text' },
        debtOrReceivableStr: { type: 'select', allowEmpty: false, loadOptions: debtOrReceivableOptions },
        customFormNameStr: { type: 'select', loadOptions: loadCustomForms },
        currencyTypeName: { type: 'select', loadOptions: () => loadConstantsByCode('CURRENCY') },
        description: { type: 'text' },
        isCustomer: YES_NO_FILTER,
        isSupplier: YES_NO_FILTER,
        isAgency: YES_NO_FILTER,
        isCustomActive: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetBankAccountTransactionMatchDefinitionListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "isCustomer") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.bankAccountTransactionMatchDefinitionId)} onDoubleClick={!item.companyId ? undefined : () => updateBankAccountTransactionMatchDefinition(item.bankAccountTransactionMatchDefinitionId)}>{item.isCustomer ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isSupplier") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.bankAccountTransactionMatchDefinitionId)} onDoubleClick={!item.companyId ? undefined : () => updateBankAccountTransactionMatchDefinition(item.bankAccountTransactionMatchDefinitionId)}>{item.isSupplier ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isAgency") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.bankAccountTransactionMatchDefinitionId)} onDoubleClick={!item.companyId ? undefined : () => updateBankAccountTransactionMatchDefinition(item.bankAccountTransactionMatchDefinitionId)}>{item.isAgency ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isCustomActive") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.bankAccountTransactionMatchDefinitionId)} onDoubleClick={!item.companyId ? undefined : () => updateBankAccountTransactionMatchDefinition(item.bankAccountTransactionMatchDefinitionId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.bankAccountTransactionMatchDefinitionId)} onDoubleClick={!item.companyId ? undefined : () => updateBankAccountTransactionMatchDefinition(item.bankAccountTransactionMatchDefinitionId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.bankAccountTransactionMatchDefinitionId)} onDoubleClick={!item.companyId ? undefined : () => updateBankAccountTransactionMatchDefinition(item.bankAccountTransactionMatchDefinitionId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.bankAccountTransactionMatchDefinitionId)} onDoubleClick={!item.companyId ? undefined : () => updateBankAccountTransactionMatchDefinition(item.bankAccountTransactionMatchDefinitionId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <BankAccountTransactionMatchDefinitionListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteBankAccountTransactionMatchDefinition}
                    updateFunction={updateBankAccountTransactionMatchDefinition}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.bankAccountTransactionMatchDefinitionId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default BankAccountTransactionMatchDefinitionList;